<template>
    <div>
        <loader v-if="loading"></loader>
        <form v-if="user" @submit.prevent="">
            <div class="row">
                <div class="col-12 col-md-6 form-group">
                    <label class="font-sm">First name</label>
                    <i class="material-icons">person_outline</i>
                    <input disabled v-model="user.first_name" name="first-name" type="text" class="form-control input-style" aria-describedby="First name" />
                </div>
                <div class="col-12 col-md-6 form-group">
                    <label class="font-sm">Last name</label>
                    <i class="material-icons">person_outline</i>
                    <input disabled v-model="user.last_name" name="last-name" type="text" class="form-control input-style" aria-describedby="Last name" />
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-md-6 form-group">
                    <label class="font-sm">Email</label>
                    <i class="material-icons">mail_outline</i>
                    <input disabled v-model="defaultEmail.email" name="email" type="email" class="form-control input-style" aria-describedby="Email" />
                </div>

                <div class="col-12 col-md-6 form-group">
                    <label class="font-sm">Phone</label>
                    <i class="material-icons">phone</i>
                    <input disabled v-model="defaultPhone.display_phone" name="phone" type="tel" class="form-control input-style" aria-describedby="Phone" />
                </div>
            </div>

            <div class="row">
                <div class="col-12 form-group">
                    <label class="font-sm">Company name</label>
                    <i class="material-icons">work_outline</i>
                    <input disabled v-model="user.travelAgency.name" name="company-name" type="text" class="form-control input-style" aria-describedby="Company name">
                </div>
            </div>
            <div class="row" v-if="user.travelAgency.parent">
                <div class="col-12 form-group">
                    <label class="font-sm">Affiliate of</label>
                    <i class="material-icons">work_outline</i>
                    <input disabled v-model="user.travelAgency.parent.name" name="affiliate-company-name" type="text" class="form-control input-style" aria-describedby="Affiliate of">
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import Loader from "./Loader";
    import { mapGetters } from "vuex"

    export default {
        components: { Loader },

        computed: {
            defaultEmail() {
                return _.first(this.user.memberEmails, {default: 1}) || {};
            },
            defaultPhone() {
                return _.first(this.user.memberPhones, {default: 1}) || {};
            },
            ...mapGetters({
                user: "Auth/user",
                loading: "Auth/loading"
            }),
        },
    }
</script>